import { fromLonLat } from 'ol/proj'
import type { Extent } from 'ol/extent'

export function useGetOlExtent(bbox: [number, number][]): Extent {
    if (!bbox || bbox.length !== 2) {
        throw new Error('Invalid bbox format. Expected [[lat, lon], [lat, lon]].')
    }

    const [[lat1, lon1], [lat2, lon2]] = bbox

    const [x1, y1] = fromLonLat([lon1, lat1])
    const [x2, y2] = fromLonLat([lon2, lat2])

    return [
        Math.min(x1, x2),
        Math.min(y1, y2),
        Math.max(x1, x2),
        Math.max(y1, y2),
    ]
}
